/* 布局 */
//前台
import Layout from "@views/layout";

const activitysignupRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
            path: "activitysignup",
            name: "ACTIVITYSIGNUP",
            meta: {
                title: "活动报名管理",
                sort: 1,
            },
            component: () => import("@views/business/activitysignup/index.vue"),
            redirect: {
                name: "ACTIVITYSIGNUP_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "ACTIVITYSIGNUP_LIST",
                    meta: {
                        title: "活动报名管理",
                        sort: 2,
                        keepAlive: true
                    },
                    component: () => import("@views/business/activitysignup/list.vue"),
                },
                
                {
                    path: "add_email",
                    name: "ACTIVITYSIGNUP_ADDEMAIL",
                    meta: {
                        title: "邮件推送",
                        parentPath: '/business/activity/list',
                        operate: true,
                    },
                    component: () => import("@views/business/activitysignup/emailForm.vue"),
                },
            ],
        },


    ],
};

export default activitysignupRouter;
